* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.grid-view {
  height: 400px;
}

.header-buttons-outside-grid {
  margin-top: calc(3 * var(--spacer));
  position: relative;
}

.header-buttons-outside-grid,
.header-buttons {
  gz-button,
  gz-select {
    margin-right: 16px;
  }
  gz-select {
    display: inline-block;
  }
}

.company-selector-field {
  display: flex;
  margin-bottom: calc(2 * var(--spacer));
}

.company-selector {
  width: auto;
  --form-field-input-width: 240px;
}
.company-selector-text {
  width: 250px;
  padding-top: 8px;
  font-size: var(--label-font-size);
  font-family: 'IBMPlex', 'IBM Plex Sans', sans-serif;
  color: var(--main-titles-inputs-600);
  display: inline-table;
}

.text-input-form-field {
  margin-bottom: -8px;
}
#domain-ip-toggle {
  --margin-bottom-wrapper: 0px;
  --margin-vertical: 0px;
}
